import { Modal } from "../../../components/commons";
import styles from "./single-invoicing-guide.modal.module.scss";
import { formatAmount } from "../../../utils";

const SingleInvoicingGuideModal = ({ invoiceGuideModal, invoiceGuideView }) => {
  return (
    <Modal
      active={invoiceGuideModal.active}
      close={invoiceGuideModal.close}
      title="Invoice Guide"
      className={styles.invoiceGuideModal}
    >
      <div className={styles.invoiceGuideMeta}>
        <div>
          <strong>Sold to</strong>
          <span>{invoiceGuideView.soldTo}</span>
        </div>
        <div>
          <strong>Date</strong>
          <span>{invoiceGuideView.date}</span>
        </div>
        <div>
          <strong>Address</strong>
          <span>{invoiceGuideView.address}</span>
        </div>
        <div>
          <strong></strong>
          <span></span>
        </div>
        <div>
          <strong>TIN</strong>
          <span>{invoiceGuideView.tin}</span>
        </div>
      </div>

      <div className={styles.invoiceGuideTable}>
        <div className={styles.tableHeader}>Item Description</div>
        <div className={styles.tableHeader}>Total Liters</div>
        <div className={styles.tableHeader}>Amount</div>

        <div className={`${styles.tableCell} ${styles.tableCellStart}`}>Fuel Purchased</div>
        <div className={styles.tableCell}>{formatAmount(invoiceGuideView.totalLiters, '', 3, 3,) + " L"}</div>
        <div className={`${styles.tableCell} ${styles.tableCellAmount}`}>{formatAmount(invoiceGuideView.fuelPurchased)}</div>

        <div className={`${styles.tableCell} ${styles.tableCellStart}`}>Discounts</div>
        <div className={styles.tableCell}></div>
        <div className={`${styles.tableCell} ${styles.tableCellAmount}`}>{formatAmount(invoiceGuideView.discounts)}</div>

        <div className={`${styles.tableCell} ${styles.tableCellStart} ${styles.tableCellBottom}`}>PLB Credit Amount</div>
        <div className={`${styles.tableCell} ${styles.tableCellBottom}`}></div>
        <div className={`${styles.tableCell} ${styles.tableCellAmount} ${styles.tableCellBottom}`}>{formatAmount(invoiceGuideView.plbCreditAmount)}</div>
      </div>

      <div className={styles.invoiceGuideTotals}>
        <div className={styles.summaryBox}>
          <div>
            <strong>VATable Sales:</strong>
            <span>{formatAmount(invoiceGuideView.vatableSales)}</span>
          </div>
          <div>
            <strong>VAT Amount:</strong>
            <span>{formatAmount(invoiceGuideView.vatAmount)}</span>
          </div>
        </div>

        <div className={styles.summaryBox}>
          <div>
            <strong>Total Sales VAT</strong>
            <span>{formatAmount(invoiceGuideView.totalSalesVat)}</span>
          </div>
          <div>
            <strong>Less: VAT</strong>
            <span>{formatAmount(invoiceGuideView.lessVat)}</span>
          </div>
          <div>
            <strong>Amount Net of VAT</strong>
            <span>{formatAmount(invoiceGuideView.amountNetOfVat)}</span>
          </div>
          <div>
            <strong>Add: VAT</strong>
            <span>{formatAmount(invoiceGuideView.addVat)}</span>
          </div>
          <div>
            <strong>Total Amount Due</strong>
            <span>{formatAmount(invoiceGuideView.totalAmountDue)}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SingleInvoicingGuideModal;
